import type { SocialLink } from '@/types/radio'
import {Facebook, Instagram, MessageCircleDashed as MessageCircle, Youtube} from 'lucide-react'

const iconMap: Record<string, typeof Instagram> = {
  instagram: Instagram,
  facebook: Facebook,
  youtube: Youtube,
  whatsapp: MessageCircle,
}

interface SocialIconsProps {
  links: SocialLink[]
  size?: number
  className?: string
}

function SocialIcons({ links, size = 18, className = '' }: SocialIconsProps) {
  const visible = (links || []).filter((item) => item?.active && item?.url)

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {visible.map((item) => {
        const Icon = iconMap[(item.platform || '').toLowerCase()] || Instagram
        return (
          <a
            key={item._id || item.platform}
            href={item.url}
            target="_blank"
            rel="noreferrer"
            aria-label={item.platform}
            className="grid h-9 w-9 place-items-center rounded-full bg-white/10 text-white transition hover:bg-[#ffd21f] hover:text-[#0b2ea8]"
          >
            <Icon size={size} />
          </a>
        )
      })}
    </div>
  )
}

export default SocialIcons
